import {
  Salaries as SalariesIcon,
  Equipment as EquipmentIcon,
  Travel as TravelIcon,
  Operating as OperatingIcon,
  SuppliesAndMaterials as SuppliesAndMaterialsIcon,
  Other as OtherIcon,
  Overview as OverviewIcon,
} from "./../../Components/Icon";
import { navigationMapBuilder } from "./helpers";
import Personnel from "./../../Pages/ProjectFinancing/Personnel";
import Equipment from "./../../Pages/ProjectFinancing/Equipment";
import Travel from "./../../Pages/ProjectFinancing/Travel";
import Services from "../../Pages/ProjectFinancing/Services";
import SuppliesMaterialServices from "./../../Pages/ProjectFinancing/SuppliesMaterialServices";
import Other from "./../../Pages/ProjectFinancing/Other";
import Overview from "./../../Pages/ProjectFinancing/Overview";

const navigation =()=>([
  {
    header: "Budget",
    links: [
      {
        text: "Personnel",
        icon: SalariesIcon,
        route: "personnel",
        component: Personnel,
        stage:"preProposal"
      },
      {
        text: "Travel",
        icon: TravelIcon,
        route: "travel",
        component: Travel,
        stage:"preProposal"
      },
      {
        text: "Equipment",
        icon: EquipmentIcon,
        route: "equipment",
        component: Equipment,
        stage:"preProposal"
      },
      {
        text: "Supplies & Materials",
        icon: SuppliesAndMaterialsIcon,
        route: "suppliesmaterialsservices",
        component: SuppliesMaterialServices,
        stage:"preProposal"
      },
      {
        text: "Services",
        icon: OperatingIcon,
        route: "services",
        component: Services,
        stage:"preProposal"
      },
      {
        text: "Other",
        icon: OtherIcon,
        route: "other",
        component: Other,
        stage:"preProposal"
      },
      {
        text: "Overview",
        icon: OverviewIcon,
        route: "overview",
        component: Overview,
        stage:"preProposal"
      },
    ],
  },
]);

const navigationMap = (parentRoute) =>
  navigationMapBuilder(parentRoute, navigation);

export default navigationMap;
